export function versionedEventName(base: string, version?: string | null): string {
    return version ? `${base}_v_${version}` : base
}
